import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import forEach from 'lodash/forEach';
import css from './index.scss';
import { DARK } from '../button/variants';
import Button from '../button';
import Messages from './messages';

class SignInCardsFormats extends Component {
    constructor(props) {
        super(props);
        this.state = {
            format: 'QR_3X3'
        };
    }
    signInCardsFormat = [{
        id: 'QR_3X3',
        name: this.props.intl.formatMessage(Messages.qr3x3),
        isDefault: true
    },
    {
        id: 'QR',
        name: this.props.intl.formatMessage(Messages.qr2x2),
        isDefault: false
    },
    {
        id: '_2X5',
        name: this.props.intl.formatMessage(Messages.f2x5),
        isDefault: false
    },
    {
        id: '_2X7',
        name: this.props.intl.formatMessage(Messages.f2x7),
        isDefault: false
    },
    {
        id: '_3X8',
        name: this.props.intl.formatMessage(Messages.f3x8),
        isDefault: false
    }
    ];

    onFormatSelection = (element) => {
        const formatId = element.target.id;
        forEach(this.signInCardsFormat, (item) => {
            if (item.id === formatId) {
                item.isDefault = true;
            } else {
                item.isDefault = false;
            }
        });

        this.setState({ format: formatId });
    }

    download = () => {
        this.props.handleOnDownloadSignInCards(this.state.format);
    }

    renderRadioButtons = () => this.signInCardsFormat.map(val => (<div className={css.formatContainer} key={val.id}> <div> <input
        checked={val.isDefault}
        className={css.group}
        id={val.id}
        name="format"
        onChange={this.onFormatSelection}
        type="radio"
        value={val.id}
    /><label htmlFor={val.id} /> </div> <div className={css.formatName}> {val.name} </div>
    </div>));

    render() {
        return (<div className={css.modalContent}>
            <div className={css.modalHeader}>
                <div className={css.modalHeaderText}>{this.props.intl.formatMessage(Messages.header)}</div>
                <div className={css.close} onClick={this.props.handleOnCancel} role="button" tabIndex={0}>&times;</div>
            </div>
            <div className={css.modalBody}>
                <div className={css.radio} >
                    {this.renderRadioButtons()}
                </div>
            </div>
            <div className={css.modalFooter}>
                <div className={css.buttonContainer}><Button
                    handleOnClick={this.download}
                    label={this.props.intl.formatMessage(Messages.download)}
                    loading={!this.props.isSignInCardDownloaded}
                    loadingLabel={this.props.intl.formatMessage(Messages.downloading)}
                    variant={DARK}
                    visible
                /></div>
            </div>
        </div>);
    }
}

SignInCardsFormats.propTypes = {
    intl: intlShape.isRequired,
    isSignInCardDownloaded: PropTypes.bool,
    handleOnCancel: PropTypes.func,
    handleOnDownloadSignInCards: PropTypes.func
};

export default injectIntl(styleable(css)(SignInCardsFormats));



// WEBPACK FOOTER //
// ./app/components/sign-in-cards-formats/index.js